<template>
  <EntryLink class="w-full flex-grow overflow-hidden px-1" :entry="note">
    <template #default="{ active }">
      <div
        class="flex items-center gap-2 rounded px-1 transition"
        :class="{ 'bg-lexmea-selection-lightest font-bold': active }"
      >
        <PaperIcon
          v-if="!columnCollapsed"
          class="h-4 w-4 flex-shrink-0"
          :colorClass="colorFromEntry(note)"
          :focus="active"
        />
        <div class="flex flex-col truncate text-left">
          <span class="truncate text-5.5pt leading-5">
            {{ note.title }}
          </span>
          <span class="-mt-1 truncate text-4.5pt">
            {{ noteTextFromColor(note.color) }}
          </span>
        </div>
      </div>
    </template>
  </EntryLink>
</template>

<script lang="ts" setup>
import type { INote } from "~/models/IUserEntry";

type Props = {
  columnCollapsed: boolean;
  note: INote;
};

defineProps<Props>();

const { noteTextFromColor } = useEntryColors();

const { colorFromEntry } = useColorFromEntry();
</script>
